import React from 'react'
import { Typography, MenuItem } from '@mui/material'

export const NoSuggestions = () => (
  <MenuItem disabled={true}>
    <Typography variant="caption">No suggestions</Typography>
  </MenuItem>
)
